<style>
</style>

<template>
  <v-app>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :multi-line="false"
      :timeout="snackbarTimeout"
    >
      {{ snackbarMessage }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container fill-height>
      <v-card width="400" class="mx-auto mt-5">
        <v-card-title class="brown white--text">
          <h2>Login</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isFormValid" lazy-validation @keyup.native.enter="validate">
            <v-text-field
              label="E-mail (or username)"
              :rules="usernameRules"
              v-model="username"
              prepend-icon="mdi-account-circle"
            />
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              v-model="password"
              :rules="passwordRules"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click="validate" color="brown white--text" :disabled="!isFormValid">
            <v-icon>mdi-login</v-icon>Login
          </v-btn>
          <v-btn to="/password-recovery" outlined color="deep-purple lighten-3">
            <v-icon>mdi-lock-question</v-icon>Password recovery
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
function checkNested(obj, level, ...rest) {
  if (obj === undefined) return false;
  if (rest.length == 0 && obj.hasOwnProperty(level)) return true;
  return checkNested(obj[level], ...rest);
}

export default {
  name: "MainWindow",
  components: {},
  data: () => ({
    isFormValid: false,
    snackbar: false,
    snackbarColor: "red darken-3",
    snackbarTimeout: 6000,
    snackbarMessage: "",
    showPassword: false,
    password: "",
    passwordRules: [v => !!v || "Password is required"],
    username: "",
    usernameRules: [v => !!v || "Username is required"]
  }),
  created() {
    this.$vuetify.theme.dark = this.$store.state.themeDarkEnabled;
  },
  methods: {
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && obj.hasOwnProperty(level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
    processErrorResponse(result) {
      if (checkNested(result, "response", "data", "error", "message")) {
        this.displayError(result.response.data.error.message);
      } else if (checkNested(result, "message")) {
        this.displayError(result.message);
      } else {
        this.displayError(result);
      }
    },
    displayError(message) {
      this.snackbarMessage = message;
      this.snackbar = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password
          })
          .then(() => this.$router.push("/"))
          .catch(result => this.processErrorResponse(result));
      }
    }
  }
};
</script>
